export default __webpack_public_path__ + "static/media/2_notification_bell.7c59b65b.svg";